
import {
  NgModule
} from '@angular/core';

import {
  FormsModule
} from '@angular/forms';

import {
  BrowserModule
} from '@angular/platform-browser';

import {
  HttpClientModule
} from '@angular/common/http';

import {
  NbActionsModule,
  NbBadgeModule,
  NbButtonModule,
  NbCardModule,
  NbDatepickerModule,
  NbIconModule,
  NbLayoutModule,
  NbListModule,
  NbSelectModule,
  NbSpinnerModule,
  NbToggleModule
} from '@nebular/theme';

import {
  HeaderModule,
  LanguageSelectModule,
  OrderedListModule,
  WysiwygModule,
  WmsRatesGroupModule
} from '../../components';

import {
  AppRoutingModule
} from '../../app/app-routing.module';

import {
  PricelistWmsService,
  ServiceService,
  RateTypeService
} from '../../providers';

import {
  PricelistWmsComponent
} from './pricelist-wms.component';

@NgModule({
  declarations: [
    PricelistWmsComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpClientModule,
    NbActionsModule,
    NbBadgeModule,
    NbButtonModule,
    NbCardModule,
    NbDatepickerModule,
    NbIconModule,
    NbLayoutModule,
    NbListModule,
    NbSelectModule,
    NbSpinnerModule,
    NbToggleModule,
    HeaderModule,
    LanguageSelectModule,
    OrderedListModule,
    WysiwygModule,
    AppRoutingModule,
    WmsRatesGroupModule
  ],
  providers: [
    PricelistWmsService,
    ServiceService,
    RateTypeService
  ]
})
export class PricelistWmsModule { }
